/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveCounselorPersonalDataRequest
 */
export interface SaveCounselorPersonalDataRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveCounselorPersonalDataRequest
     */
    userCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveCounselorPersonalDataRequest
     */
    team: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveCounselorPersonalDataRequest
     */
    isTeamLeader: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveCounselorPersonalDataRequest
     */
    mobileNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveCounselorPersonalDataRequest
     */
    phoneExtension: string | null;
}

/**
 * Check if a given object implements the SaveCounselorPersonalDataRequest interface.
 */
export function instanceOfSaveCounselorPersonalDataRequest(value: object): value is SaveCounselorPersonalDataRequest {
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('isTeamLeader' in value) || value['isTeamLeader'] === undefined) return false;
    if (!('mobileNumber' in value) || value['mobileNumber'] === undefined) return false;
    if (!('phoneExtension' in value) || value['phoneExtension'] === undefined) return false;
    return true;
}

export function SaveCounselorPersonalDataRequestFromJSON(json: any): SaveCounselorPersonalDataRequest {
    return SaveCounselorPersonalDataRequestFromJSONTyped(json, false);
}

export function SaveCounselorPersonalDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveCounselorPersonalDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userCode': json['userCode'],
        'team': json['team'],
        'isTeamLeader': json['isTeamLeader'],
        'mobileNumber': json['mobileNumber'],
        'phoneExtension': json['phoneExtension'],
    };
}

export function SaveCounselorPersonalDataRequestToJSON(json: any): SaveCounselorPersonalDataRequest {
    return SaveCounselorPersonalDataRequestToJSONTyped(json, false);
}

export function SaveCounselorPersonalDataRequestToJSONTyped(value?: SaveCounselorPersonalDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userCode': value['userCode'],
        'team': value['team'],
        'isTeamLeader': value['isTeamLeader'],
        'mobileNumber': value['mobileNumber'],
        'phoneExtension': value['phoneExtension'],
    };
}

